import styled from "styled-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { RadioButton } from "@similarweb/ui-components";

export const StyledRadioButton = styled(RadioButton)`
    label {
        display: none;
    }
`;

export const Container = styled(FlexColumn)<{ isSelected: boolean }>`
    box-sizing: border-box;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 4px;
    width: 245px;
    max-height: 92px;
    padding: 16px 12px;
    gap: 4px;
    cursor: pointer;

    background-color: ${({ isSelected }) => (isSelected ? colorsPalettes.blue[50] : "transparent")};
    border-color: ${({ isSelected }) => (isSelected ? colorsPalettes.blue[400] : colorsPalettes.carbon[50])};

    &:hover {
        background-color: ${colorsPalettes.blue[50]};
        border-color: ${({ isSelected }) => (isSelected ? colorsPalettes.blue[400] : colorsPalettes.blue[50])};
    }
`;

export const Top = styled(FlexRow)`
    justify-content: space-between;
`;

export const Title = styled.div`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[500])}
`;
export const Text = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[400])}
`;
